var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6188 10.2746L11.6651 8.32085C10.9673 7.62308 9.78113 7.90222 9.50202 8.80928C9.29269 9.4373 8.59493 9.78618 7.96694 9.6466C6.57141 9.29772 4.68744 7.48353 4.33856 6.01822C4.12923 5.39021 4.54789 4.69244 5.17588 4.48314C6.08297 4.20403 6.36208 3.01783 5.66431 2.32007L3.71057 0.366327C3.15236 -0.122109 2.31504 -0.122109 1.82661 0.366327L0.500853 1.69208C-0.8249 3.08761 0.640406 6.78576 3.9199 10.0653C7.1994 13.3448 10.8976 14.8799 12.2931 13.4843L13.6188 12.1586C14.1073 11.6003 14.1073 10.763 13.6188 10.2746Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.a0037928805d2f19dda212a3bf679b04.svg";
export { ForwardRef as ReactComponent };